import React, { useContext } from "react";
import { FaArrowRightLong } from "react-icons/fa6";
import { Training_details } from "./Training_details/Training_datas";
import Skills from "./Skills/Skills";
import { contextData } from "../../App";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./TrainingPage.css";
import TieCompani from "./TieCompani/TieCompani";
import { Helmet } from "react-helmet-async";

export default function TrainingPage() {
  const { blur, handle, adbanner, closeBanner } = useContext(contextData);
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>IT & Software Training Courses for Skill Growth</title>
        <meta name="description"
          content="Join practical IT and software training programs to boost your skills in web, mobile, ERP, CRM, e-commerce, and more. Learn hands-on from experts." />

        <meta name="keywords" content="Software Training Courses in Coimbatore, IT Training Institute in Coimbatore" />

        {/* <!-- Canonical URL --> */}
        <link rel="canonical" href="https://kitkattech.com/training" />

        {/* <!-- Hreflang Tags --> */}
        <link rel="alternate" hrefLang="en-US" href="https://kitkattech.com/training" />
        <link rel="alternate" hrefLang="en-GB" href="https://kitkattech.com/training" />
        <link rel="alternate" hrefLang="en-MY" href="https://kitkattech.com/training" />
        <link rel="alternate" hrefLang="en-SG" href="https://kitkattech.com/training" />
        <link rel="alternate" hrefLang="en-AE" href="https://kitkattech.com/training" />
        <link rel="alternate" hrefLang="x-default" href="https://kitkattech.com/training" />
      </Helmet>


      <div className="training-container">
        {/* Header Section */}
        <div className="hero-section">
          <div className="hero-content">
            <h1>Grow Your Skills with Our IT & Software Training</h1>
            <p>
              We take pride in being a leading software training institute that
              has empowered individuals and organizations to thrive in the
              dynamic world of technology. Our client partnerships are a
              testament to the quality of education and the real-world skills we
              impart to our students.
            </p>
            <button className="enquiry-btn" onClick={() => navigate("/mail")}>
              Enquiry Now <FaArrowRightLong />
            </button>
          </div>
          <div className="hero-image">
            <img src={require("./img/banar.png")} alt="Kitkat Academy" />
          </div>
        </div>

        {/* Courses Section */}
        <div className="courses-section">
          <h2>Our Courses</h2>
          <p className="course-description">
            Learn new skills, pursue your interests or advance your career with
            our distinctive course catalogues. Our updated syllabus covers all industry
            standards.
          </p>
          <Container>
            <div className="course-grid">
              {Training_details.map((course) => (
                <div key={course.id} className="course-box" onClick={() => navigate(`/training/${course.slug}`)}>
                  <div className="card">
                    <div className="card-image">
                      <img src={course.img} alt={course.title} />
                    </div>
                    <h1>{course.title}</h1>
                    <button className="view-btn" >
                      View More <FaArrowRightLong />
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div>
              <TieCompani />
            </div>
          </Container>
        </div>

      </div>

      {/* Full-Screen Ad */}
      {/* <div ref={adbanner} className="full-screen-ad" id="adBanner">
        <Skills />
        <span className="close-btn" onClick={closeBanner}>✕</span>
      </div> */}
    </>
  );
}
